module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.45b47f3e.woff";